module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Dropdown-Dropdown 1_down_Black.cc8f99e4.svg";